import axios, { AxiosResponse } from "axios"
import tmcryptoUtils from "./tmcrypto.utils";

export default new class httpUtils {

    post(url: string | URL, body: any, options?: { headers?: HeadersInit }) {
        return new Promise<AxiosResponse<any>>((resolve, reject) => {
            try {
                let headers = new Headers(options && options.headers || {});

                headers.set("Content-Type", "text/plain");
                headers.set("X-Encrypted", "tmcrypto");

                const dataH: any = {};
                headers.forEach((v, k) => {
                    dataH[k] = v;
                })
                
                console.log("HEADERS:", dataH)
                
                tmcryptoUtils.encrypt(body)
                    .then((data) => {
                        axios.post(url instanceof URL ? url.href : new URL(url).href, data, {
                            headers: dataH
                        })
                            .then(async (response) => {
                                if(response.headers["x-encrypted"] === "tmcrypto" && typeof response.data === "string") {
                                    response.data = await tmcryptoUtils.decrypt(response.data);

                                    const contentType = response.headers["content-type"];

                                    if(typeof contentType === "string") {
                                        const [type] = contentType.split(";");

                                        if(type === "application/json") {
                                            response.data = JSON.parse(response.data);
                                        }
                                    }

                                    console.log(response.data);
                                }
                                resolve(response);
                            })
                            .catch(async (err) => {
                                try {
                                    if(axios.isAxiosError(err)) {
                                        if(err.response && err.response.headers["x-encrypted"] === "tmcrypto" && typeof err.response.data === "string") {
                                            err.response.data = await tmcryptoUtils.decrypt(err.response.data);

                                            const contentType = err.response.headers["content-type"];

                                            if(typeof contentType === "string") {
                                                const [type] = contentType.split(";");

                                                if(type === "application/json") {
                                                    err.response.data = JSON.parse(err.response.data);
                                                }
                                            }

                                            console.log(err.response.data);
                                        }
                                    }
                                    reject(err);
                                }
                                catch(err2) {
                                    console.error(err2)
                                    reject(err);
                                }
                            });
                    })
                    .catch(reject);
            }
            catch(err) {
                reject(err);
            }
        });
    }
    
}